import { useCallback } from 'react';
import {
  formatPrice as formatPriceHelper,
  getCurrencySymbol,
  DEFAULT_CURRENCY,
} from '../helpers/currency';

/**
 * Hook pour accéder à la devise de l'organisation et formater les prix
 *
 * @example
 * const { currency, formatPrice, currencySymbol } = useCurrency();
 *
 * // Afficher un prix formaté
 * <span>{formatPrice(1250)}</span> // Affiche "12,50 €" ou "CHF 12.50"
 *
 * // Accéder au symbole seul
 * <span>{currencySymbol}</span> // Affiche "€" ou "CHF"
 */
export function useCurrency() {
  const currency = DEFAULT_CURRENCY;

  /**
   * Formate un prix en centimes vers une chaîne formatée selon la devise de l'organisation
   */
  const formatPrice = useCallback(
    (priceInCents: number | null | undefined): string => {
      return formatPriceHelper(priceInCents, currency);
    },
    [currency],
  );

  /**
   * Le symbole de la devise courante
   */
  const currencySymbol = getCurrencySymbol(currency);

  return {
    /** Code ISO de la devise (EUR, CHF, USD) */
    currency,
    /** Fonction pour formater un prix en centimes */
    formatPrice,
    /** Symbole de la devise (€, CHF, $) */
    currencySymbol,
  };
}
